










































































import { Component, Prop, Vue } from "vue-property-decorator";
@Component
export default class CalcCardSkeleton extends Vue {
    @Prop({ default: "sm" }) view: string;
    @Prop({ default: null }) logo: string; // link to logo
    get br() {
        return {
            sm: this.view == "sm",
            md: this.view == "md",
            lg: this.view == "lg",
        };
    }
    get small() {
        return this.view === "sm";
    }
}
